import type { FC } from 'react';
import { useEffect } from 'react';

import { useWineryTagManager } from '@xing-com/crate-companies-shared';
import { useLocation } from '@xing-com/crate-core-router';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { Outlet } from '@xing-com/crate-xinglet';
import { useFeatureSwitch } from '@xing-com/hub';

import { MainLayout } from './components/layouts/main-layout';
import { LoggedInPage } from './components/logged-in-page/logged-in-page';
import { resetCompaniesDataStore } from './store/companies-data-store';

export const App: FC = () => {
  const { isLoggedIn } = useLoginState();
  const location = useLocation();
  useWineryTagManager();

  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  const AppComponent =
    isLoggedIn && !showNewLoggedInOverview ? LoggedInPage : MainLayout;

  useEffect(() => {
    resetCompaniesDataStore();
  }, [location.pathname]);

  return (
    <AppComponent>
      <Outlet />
    </AppComponent>
  );
};
